<div class="column">
  <div class="columns box-overflow homework_wrapper scroll-bar">
    <div class="column is-offset-2 is-8">
      <div class="columns">
        <div class="column is-three-quarters">
          <p class="control has-icons-left has-icons-right">
            <input
              class="input ng-pristine ng-valid ng-touched"
              (keyup)="searchInList.next($event)"
              [(ngModel)]="search"
              inputfocus
              placeholder="Search here..."
              type="text"
            /><a class="icon is-small is-left" title="Search"
              ><i class="fa fa-search"></i></a
            ><span class="input-bar"></span>
          </p>
        </div>
        <!-- <div class="column homework_sort"> -->
        <select
          class="column homework_sort select"
          [(ngModel)]="sortBy"
          (change)="getTaskList(0)"
        >
          <option value="status">Sort by Status</option>
          @if (isUserRole != userRole) {
          <option value="assigned_by">Sort by Assigned By</option>
          } @if (isUserRole == userRole) {
          <option value="assigned_to">Sort by Assigned To</option>
          }
          <option value="due_date">Sort by Due Date</option>
          <option value="assigned_date">Sort by Assigned Date</option>
        </select>
        <!-- <div class="dropdown " [ngClass]="{'is-active': sortOptions === true}">
        <div class="dropdown-trigger">
          <span class=" control has-icons-right is-small has-tooltip-left" aria-haspopup="true" aria-controls="dropdown-menu2"  data-tooltip="Sort By ">
            <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          </span>
        </div>

        <div class="dropdown-menu" id="dropdown-menu2" role="menu" (change)="getTaskList(0)" [(ngModel)]="sortBy">
          <div class="dropdown-content">
            <a class="dropdown-item" name="status">
              Sort by Status
            </a>
            <a class="dropdown-item" name="assigned_to">
              Sort by Assigned To
            </a>
            <a class="dropdown-item" name="assigned_by">
              Sort by Assigned By
            </a>
            <a class="dropdown-item" name="due_date">
              Sort by Due Date
            </a>
            <a class="dropdown-item" name="assigned_date">
              Sort by Assigned Date
            </a>
          </div>
        </div>
      </div> -->
        <!-- </div> -->
        <div
          class="column homework_filter"
          [ngClass]="{ activeFilter: activeFilter == true }"
          (click)="homeworkFilter()"
        >
          <span
            class="control has-icons-right has-tooltip-left"
            data-tooltip="Assignment Filter"
          >
            <i class="fa fa-filter" aria-hidden="true"></i>
          </span>
        </div>
      </div>
      <div
        class="homework-column"
        [ngClass]="{ 'active-column': activeFilter == true }"
      >
        <div class="columns">
          <div class="column">
            <!-- <input class="input" type="text" placeholder="Text input"> -->
            <div class="select is-multiple">
              <ng-select
                [multiple]="true"
                class="customFilter"
                placeholder="Filter by Status"
                (change)="getTaskList(0)"
                [(ngModel)]="statusFilter"
              >
                @for (s of statusList; track s; let i = $index) {
                <ng-option class="is-capitalized" [value]="i">{{
                  s
                }}</ng-option>
                }
              </ng-select>
            </div>
          </div>
          <div class="column">
            <!-- <input class="input" type="text" placeholder="Text input"> -->
            <div class="select is-multiple">
              <ng-select
                [multiple]="false"
                class="customFilter"
                placeholder="Filter by Group/Non Group"
                (change)="getTaskList(0)"
                [(ngModel)]="taskFilter"
              >
                @for (g of groupList; track g) {
                <ng-option class="is-capitalized" [value]="g.value">{{
                  g.name
                }}</ng-option>
                }
              </ng-select>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <!-- <input class="input" type="text" placeholder="Text input"> -->
            <div class="select is-multiple">
              <ng-select
                [multiple]="true"
                class="customFilter"
                placeholder="Filter by Assigned To"
                (change)="getTaskList(0)"
                [(ngModel)]="assignee"
              >
                @for (data of isActiveUser; track data) {
                <ng-option class="is-capitalized" [value]="data.user_id">{{
                  data.first_name
                }}</ng-option>
                }
              </ng-select>
            </div>
          </div>
          <div class="column">
            <div class="field is-horizontal">
              <div class="field-body" (change)="getTaskList(0)">
                <div class="field">
                  <input
                    class="input"
                    type="date"
                    data-is-range="true"
                    [(ngModel)]="startdateFilter"
                  />
                </div>
                <div class="field">
                  <input
                    class="input"
                    type="date"
                    data-is-range="true"
                    [(ngModel)]="enddateFilter"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      @for (item of taskLists; track item; let i = $index) {
      <div class="columns">
        <section class="accordions" style="width: 100%">
          @if (item?.showDay) {
          <div class="column has-text-centered timing">
            <span class="time-history">{{ item.day }}</span>
          </div>
          }
          <article
            class="accordion"
            [ngClass]="{ 'is-active': isAssignActive[item.pin_id] }"
            (click)="showHideAssignment(item.pin_id)"
          >
            <div class="accordion-header toggle">
              <p class="homework-title" [innerHTML]="item.task"></p>
              @if (isUserRole != userRole) {
              <div>
                <span
                  class="is-size-7 select is-small tag is-light"
                  [ngClass]="{
                    'is-info': item.status === 0,
                    'is-primary': item.status === 1,
                    'is-success': item.status === 2,
                    'is-danger': item.status === 3
                  }"
                >
                  <select
                    [(ngModel)]="item.status"
                    class="is-capitalized"
                    (change)="updatePinTaskStatus(item.pin_id, $event)"
                    [disabled]="isUserRole == userRole"
                  >
                    @for (l of statusList; track l; let i = $index) {
                    <option value="{{ i }}">
                      <span class="tag is-light is-info">{{ l }}</span>
                    </option>
                    }
                  </select>
                </span>
              </div>
              }
            </div>
            <div class="accordion-body">
              <div class="accordion-content">
                <div class="columns">
                  <div class="column is-one-quarter content">
                    <p class="task-content size-14 is-bold">
                      <strong>Due Date</strong> <br />
                      <span
                        class="file-name-list"
                        [innerHTML]="item.task_due_date | date : 'dd MMM yyyy'"
                      ></span>
                    </p>
                  </div>
                  <div class="column is-one-quarter content">
                    <p class="task-content size-14">
                      <strong>Assigned Date </strong><br />
                      <span
                        class=""
                        [innerHTML]="item.created_at | date : 'dd MMM yyyy'"
                      ></span>
                    </p>
                  </div>
                  @if (isUserRole == userRole) {
                  <div class="column is-one-quarter content">
                    <div class=" ">
                      <p class="task-content size-14">
                        <strong>Assigned To</strong> <br />
                        @for (i of item.assigned_to; track i) {
                        <span>{{ i }}<br /></span>
                        }
                      </p>
                    </div>
                  </div>
                  } @else {
                  <div class=" ">
                    <p class="task-content size-14">
                      <strong>Assigned By</strong> <br />
                      <span class="" [innerHTML]="item.assigned_by"></span>
                    </p>
                  </div>
                  } @if (isUserRole == userRole) {
                  <div class="column is-one-quarter content">
                    <p class="task-content size-14">
                      <strong>Status</strong><br />
                      <span>{{ item.status }}</span>
                    </p>
                  </div>
                  }
                </div>
              </div>
            </div>
          </article>
        </section>
        <pagination-loader
          [showFetchLoader]="showPaginateSpinner"
        ></pagination-loader>
      </div>
      }
    </div>
  </div>
</div>
